if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const quantityGifts = this.getQuantityGifts();
        const unlockedGifts = quantityGifts?.getUnlockedGiftItems?.() || [];
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = unlockedGifts.length
          ? this.buildGiftItemsFormData(formData, unlockedGifts, quantityGifts)
          : formData;

        this.skipCart = false;
        const variantInput = this.form.querySelector('[name=id]');
        console.log('Variant input:', variantInput);
        console.log('Variant input dataset:', variantInput?.dataset);
        console.log('Skip cart dataset:', variantInput?.dataset?.skipCart);
        if (variantInput?.dataset?.skipCart === 'true') {
          this.skipCart = true;
          console.log('Skip cart enabled');
        }

        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(
                `${routes.cart_add_url}`,
                this.getUpsellProductConfig()
              );
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (this.skipCart) {
              console.log('Redirecting to checkout');
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }



      getQuantityGifts() {
        const productInfo = this.closest('product-info');
        return productInfo?.querySelector(`quantity-gifts[data-section="${productInfo?.dataset?.section}"]`) || null;
      }

      buildGiftItemsFormData(formData, unlockedGifts, quantityGifts) {
        const itemsFormData = new FormData();
        const mainId = formData.get('id');
        const mainQuantity = formData.get('quantity') || '1';
        const allGiftItems = quantityGifts?.getAllGiftItems?.() || [];
        const productInfo = this.closest('product-info');
        const productHandle = productInfo?.dataset?.url?.split('?')[0]?.split('/products/')[1] || '';

        itemsFormData.append('items[0][id]', mainId);
        itemsFormData.append('items[0][quantity]', mainQuantity);
        if (allGiftItems.length) {
          itemsFormData.append('items[0][properties][_gift_config]', JSON.stringify(allGiftItems));
        }
        if (productHandle) {
          itemsFormData.append('items[0][properties][_gift_main_handle]', productHandle);
        }

        for (const [key, value] of formData.entries()) {
          if (['id', 'quantity', 'sections', 'sections_url'].includes(key)) continue;

          const propertyMatch = key.match(/^properties\[(.*)\]$/);
          if (propertyMatch) {
            itemsFormData.append(`items[0][properties][${propertyMatch[1]}]`, value);
            continue;
          }

          const attributeMatch = key.match(/^attributes\[(.*)\]$/);
          if (attributeMatch) {
            itemsFormData.append(`attributes[${attributeMatch[1]}]`, value);
            continue;
          }

          itemsFormData.append(`items[0][${key}]`, value);
        }

        unlockedGifts.forEach((gift, index) => {
          const itemIndex = index + 1;
          itemsFormData.append(`items[${itemIndex}][id]`, gift.id);
          itemsFormData.append(`items[${itemIndex}][quantity]`, '1');
          itemsFormData.append(`items[${itemIndex}][properties][_is_quantity_gift]`, 'true');
          itemsFormData.append(`items[${itemIndex}][properties][_gift_for_variant]`, String(mainId));
          itemsFormData.append(`items[${itemIndex}][properties][_gift_threshold]`, String(gift.threshold));
          if (gift.handle) {
            itemsFormData.append(`items[${itemIndex}][properties][_gift_handle]`, gift.handle);
          }
        });

        if (this.cart) {
          itemsFormData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          itemsFormData.append('sections_url', window.location.pathname);
        }

        return itemsFormData;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
